import goTo from 'vuetify/es5/services/goto'

export default function(value){
    return goTo(value);
}
